<template>
  <div>
    <map-tool-elem @maptoolClick="maptoolClick" :tools="tools"></map-tool-elem>
    <div id="pointMarkPop" v-if="showPopDiv">
      <div style="position: relative">
        <div class="popHead" id="popHead">{{ popTitle }}</div>
        <img
          :src="require('../../assets/image/common/pop_icon_close_default.png')"
          @click="closePopAction()"
          class="close-btn"
        />
      </div>
      <div class="popDiv">
        <label class="popLabel">{{ '名称' }}</label>
        <div class="popTextarea">
          <el-input
            id="nameInput"
            v-model="toolName"
            autocomplete="off"
            autofocus="true"
            maxlength="20"
            spellcheck="false"
            ref="toolName"
          ></el-input>
        </div>
      </div>
      <div class="popBtn">
        <el-button class="cancel-btn" @click="cancelClick"> {{ '取消' }}</el-button>
        <el-button class="confirm-btn" @click="confirmClick">{{ '确定' }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
import L from 'leaflet'
import 'leaflet-semicircle'
import MapToolElem from './MapToolElem.vue'
import {
  escapeHTMLString,
  transMarkType,
  addCircleMarker,
  calcAngleNorth,
  judgeName,
  isInArray
} from '../../assets/js/utils/utils'
// import { EventBus } from '../../event-bus.js'

import iconClose from '../../assets/image/maptool/tool_icon_close.png'
import $ from 'jquery'
import httpClient from '../../http'

import '../../assets/js/measure/leaflet.measure.js'
export default {
  name: 'rg-map-tool',
  props: {
    tools: {
      type: Array,
      default: () => ['distance', 'area', 'angle', 'markPoint', 'markLine', 'markArea', 'clear']
    },
    iconUrl: {
      type: String,
      default: require('../../assets/image/maptool/tool_icon_gauge-point_point.png')
    },
    iconSize: {
      type: Array,
      default: () => [24, 41]
    },
    iconAnchor: {
      type: Array,
      default: () => [12, 41]
    },
    addRequestUrl: {
      type: String,
      default: '/api-forest/tool/add'
    },
    updateRequestUrl: {
      type: String,
      default: '/api-forest/tool/update'
    },
    deleteRequestUrl: {
      type: String,
      default: '/api-forest/tool/delete'
    },
    emptyRequestUrl: {
      type: String,
      default: '/api-forest/tool/empty'
    },
    getListRequestUrl: {
      type: String,
      default: '/api-forest/tool/list'
    },
    isFullScreen: {
      // 是否包含左侧菜单栏
      type: Boolean,
      default: true
    }
  },
  components: {
    MapToolElem
  },
  data() {
    return {
      areaMeasure: {
        points: [],
        layers: L.layerGroup(),
        polygon: null
      },
      popTitle: '',
      markerType: '',
      markerObj: {},
      dotIcon: null,
      isDrawing: false, // 在画图中
      toolName: '',
      showPopDiv: false, // 标点线面的弹框
      currentToolId: '',
      canDelete: false,
      clickType: '',
      timeStr: '',
      markerFlag: false,
      // 标点
      sendPointInfo: null,
      dotTimeStr: '',
      dotState: false, // false-未存储的点，true-已存储的点
      dotList: [],
      lineList: [],
      areaList: [],
      eventPoint: '',
      // 标线
      points: [],
      lines: null,
      tempCircleMarker: {},
      circleMarker: {},
      lineTimeStrCircle: '',
      TempLines: null,
      sendLineInfo: null,
      lineTimeStr: '',
      lineState: false,
      circleMarkerSave: {},
      circleTimeStrs: '',
      targetLine: null,
      // 标面
      pointsA: [],
      tempLinesA: null,
      linesA: null,
      areaTempCircleMarker: {},
      areaTimeStrCircle: '',
      sendAreaInfo: null,
      areaTimeStr: '',
      areaCircleMarker: {},
      coverState: false,
      areaCircleMarkerSave: {},
      areaCircleTimeStrs: '',
      targetArea: null,
      // 测角
      pointsAngle: [],
      tempAngles: null,
      angles: {},
      sendAngleInfo: null,
      angleTempCircleMarker: {},
      angleTimeStrCircle: '',
      angleCircleMarker: {},
      angleCircleTimeStrs: '',
      angleCloseObj: {}, // 关闭按钮
      angleTooltip: {}, //每个角度的悬浮框提示
      angleSemi: {}, //每个角度的弧度展示
      angleTimeStr: '',

      adding: false,
      editing: false,
      deleting: false,
      emptying: false,
      isPC: false,
      timer: null,
      measureRed: '#be221d'
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      // 在组件销毁时，移除键盘事件监听器
      window.removeEventListener('keyup', this.handleKeyUp)
      // 移除键盘事件监听器
      window.removeEventListener('keydown', this.handleKeyDown)
    }
  },
  created() {
    console.log('created')

    // EventBus.$on('zxp-map', (newValue) => {
    //   console.log('zxp-map：' + newValue)
    // })
  },
  mounted() {
    console.log('tool mounted')
    console.log(this.$rgMap)
    console.log(L.control)

    this.initMapAction()
    this.dotIcon = L.icon({
      iconUrl: this.iconUrl,
      iconSize: this.iconSize,
      iconAnchor: this.iconAnchor
    })
    this.getToolDatas()
    if (typeof window !== 'undefined') {
      // 可以安全地使用 window

      // 在组件挂载时，为window对象添加键盘事件监听器
      window.addEventListener('keyup', this.handleKeyUp)
      // 为window对象添加键盘事件监听器
      window.addEventListener('keydown', this.handleKeyDown)
    }
    setTimeout(() => {
      L.control.measure().addTo(this.$rgMap) // 测距初始化功能
    }, 1000)

    // RgMap.events.on("mapReady", (newValue) => {
    // EventBus.$emit("zxp", 111)
    // EventBus.$on("zxp-map", (newValue) => {
    //   this.$rgMap = newValue
    //   console.log("eventbus")
    //   console.log(this.$rgMap)
    //   this.$rgMap.on("click", this.onMapClick)
    //   this.$rgMap.on("dblclick", this.doubleClick)
    //   this.$rgMap.on("contextmenu", this.doubleClick)
    // })
  },
  methods: {
    handleKeyUp(event) {
      if (event.key === 'Delete') {
        // 在此处处理删除操作
        this.commonDealDelete(event)
      }
    },
    handleKeyDown(event) {
      if (event.keyCode === 8) {
        // 在此处处理回退操作
        this.commonDealDelete(event)
      }
    },
    commonDealDelete(event) {
      const ele = event.target
      if (ele.id !== 'nameInput') {
        if (this.canDelete) {
          // 点击选中哪个才能删哪个，不选中不能删除
          if (this.markerType === 1) {
            // 点
            this.deleteSingle(this.eventPoint.target.options.toolId)
          }
          if (this.markerType === 2) {
            // 线
            const deleteLineId = this.eventLine.target
              ? this.eventLine.target.options.toolId
              : this.eventLine.options.toolId
            this.deleteSingle(deleteLineId)
          }
          if (this.markerType === 3) {
            // 面
            const deleteAreaId = this.eventCover.target
              ? this.eventCover.target.options.toolId
              : this.eventCover.options.toolId
            this.deleteSingle(deleteAreaId)
          }
        }
      }
    },
    initMapAction() {
      this.$rgMap.on('click', this.onMapClick)
      this.$rgMap.on('dblclick', this.doubleClick)
      this.$rgMap.on('contextmenu', this.doubleClick)
    },
    // 点击地图工具图标
    maptoolClick(e) {
      console.log(e)
      if (this.showPopDiv) {
        return
      }
      if (!this.global.showManualLayer) {
        this.$message.warning('手动标注图层未展示，请至图层选择处展示该图层')
        return
      }
      this.markerType = transMarkType(e)
      this.markerFlag = true
      if (this.markerType === 2) {
        // 标线
        L.currentAction = 'markLine'
        this.points = []
        this.lines = L.polyline([])
        this.tempLines = L.polyline([])
      }
      if (this.markerType === 3) {
        // 标面
        L.currentAction = 'markArea'
        this.pointsA = []
        this.linesA = L.polyline([])
        this.tempLinesA = L.polyline([], { dashArray: [5, 10] })
      }
      if (this.markerType === 6) {
        // 测角
        L.currentAction = 'measure_angle'
        this.pointsAngle = []
        this.isDrawing = true
        this.angleTimeStr = new Date().getTime()
        this.angles[this.angleTimeStr] = L.polyline([], { weight: 3 })
        this.tempAngles = L.polyline([])
        this.$rgMap.on('zoomend', this.onMapZoom)
      }
      if (this.markerType === 5) {
        // 清空
        this.clearFn()
      }
      $('#toolBox').addClass('canotclick')
      if (this.markerType !== 4 && this.markerType !== 5) {
        this.isDrawing = true
        this.addCrosshairClass()
        this.$rgMap.on('click', this.onMapClick)
        this.$rgMap.on('dblclick', this.doubleClick)
        this.$rgMap.on('contextmenu', this.doubleClick)
      }
    },
    onMapZoom(e) {
      const zoom = e.target.getZoom()
      const radius = this.getRadiusByZoom(zoom)
      if (this.angleSemi) {
        for (let i in this.angleSemi) {
          this.angleSemi[i].setRadius(radius)
        }
      }
    },
    doubleClick(e) {
      if (!this.markerFlag) return
      if (this.markerType === 2) {
        // 标线
        this.$rgMap.removeLayer(this.lines)
        this.lineTimeStr = new Date().getTime()
        this.currentToolId = this.lineTimeStr
        this.lineState = false
        this.global.lineObj[this.lineTimeStr] = L.polyline(this.points, {
          toolId: this.lineTimeStr
        })
          .addTo(this.global.manualLayerGroup)
          .on('dblclick', (e) => {
            this.drawLineDBclick(e, e.target._popup._content)
          })
          .on('click', (e) => {
            this.drawLineclick(e)
          })
        for (const key in this.tempCircleMarker) {
          this.$rgMap.removeLayer(this.tempCircleMarker[key])
        }
        this.points.forEach((item, index) => {
          const latlng = {
            lat: item[0],
            lng: item[1]
          }
          this.circleTimeStrs = this.lineTimeStr + '_circle_' + index
          this.circleMarker[this.circleTimeStrs] = addCircleMarker(latlng, this.lineTimeStr)
            .addTo(this.global.manualLayerGroup)
            .on('dblclick', (e) => {
              this.targetLine = null
              for (const i in this.global.lineObj) {
                if (this.circleTimeStrs.indexOf(i) !== -1) {
                  this.targetLine = this.global.lineObj[i]
                }
              }
              this.drawLineDBclick(e, this.targetLine._popup._content)
            })
            .on('click', () => {
              for (const i in this.global.lineObj) {
                if (this.circleTimeStrs.indexOf(i) !== -1) {
                  this.targetLine = this.global.lineObj[i]
                }
              }
              this.drawLineclick(this.targetLine)
            })
        })
        this.$rgMap.addLayer(this.global.manualLayerGroup)
        this.$rgMap.off('mousemove', this.onMove)
        this.$rgMap.off('dblclick')
        this.tempLines.remove()
        $('#toolBox').removeClass('canotclick')
        this.popTitle = '标线信息'
      }
      if (this.markerType === 3) {
        // 标面
        this.$rgMap.removeLayer(this.tempLinesA)
        this.$rgMap.removeLayer(this.linesA)
        this.areaTimeStr = new Date().getTime()
        this.currentToolId = this.areaTimeStr
        this.coverState = false
        this.global.areaObj[this.areaTimeStr] = L.polygon(this.pointsA, {
          toolId: this.areaTimeStr
        })
          .addTo(this.global.manualLayerGroup)
          .on('dblclick', (e) => {
            this.drawAreaDBclick(e, e.target._popup._content)
          })
          .on('click', (e) => {
            this.drawAreaclick(e)
          })
        for (const key in this.areaTempCircleMarker) {
          this.$rgMap.removeLayer(this.areaTempCircleMarker[key])
        }
        this.pointsA.forEach((item, index) => {
          const latlng = {
            lat: item[0],
            lng: item[1]
          }
          this.areaCircleTimeStrs = this.areaTimeStr + '_circle_' + index
          this.areaCircleMarker[this.areaCircleTimeStrs] = addCircleMarker(latlng, this.areaTimeStr)
            .addTo(this.global.manualLayerGroup)
            .on('dblclick', (e) => {
              let targetArea = null
              for (const i in this.global.areaObj) {
                if (this.areaCircleTimeStrs.indexOf(i) !== -1) {
                  targetArea = this.global.areaObj[i]
                }
              }
              this.drawAreaDBclick(e, targetArea._popup._content)
            })
            .on('click', () => {
              let targetArea = null
              for (const i in this.global.areaObj) {
                if (this.areaCircleTimeStrs.indexOf(i) !== -1) {
                  targetArea = this.global.areaObj[i]
                }
              }
              this.drawAreaclick(targetArea)
            })
        })
        this.$rgMap.addLayer(this.global.manualLayerGroup)
        this.$rgMap.off('mousemove', this.onMove)
        this.$rgMap.off('dblclick')
        this.tempLinesA.remove()
        $('#toolBox').removeClass('canotclick')
        this.popTitle = '标面信息'
      }
      if (this.markerType === 6) {
        // 测角
        for (const key in this.angleTempCircleMarker) {
          this.$rgMap.removeLayer(this.angleTempCircleMarker[key])
        }
        let len = this.pointsAngle.length
        if (len === 0) return
        this.pointsAngle.forEach((item, index) => {
          const latlng = {
            lat: item[0],
            lng: item[1]
          }
          this.angleCircleTimeStrs = this.angleTimeStr + '_circle_' + index
          this.angleCircleMarker[this.angleCircleTimeStrs] = addCircleMarker(
            latlng,
            this.angleTimeStr,
            this.measureRed
          ).addTo(this.global.manualLayerGroup)
        })
        this.tempAngles.remove()
        this.angleCloseObj[this.angleTimeStr] = L.marker(this.pointsAngle[len - 1], {
          icon: L.icon({
            iconUrl: iconClose,
            iconSize: [12, 12]
          }),
          draggable: false,
          toolId: this.angleTimeStr
        })
          .addTo(this.global.manualLayerGroup)
          .on('click', (e) => {
            const toolId = e.target.options.toolId

            let layers = this.global.manualLayerGroup._layers
            this.groupDeleteLayer(this.angleCloseObj[toolId], layers)
            this.groupDeleteLayer(this.angles[toolId], layers)

            this.$rgMap.removeLayer(this.angleCloseObj[toolId])
            this.$rgMap.removeLayer(this.angles[toolId])

            for (const i in this.angleCircleMarker) {
              // 刚画的的圆圈点点
              if (i.indexOf(toolId) !== -1) {
                this.groupDeleteLayer(this.angleCircleMarker[i], layers)
                this.$rgMap.removeLayer(this.angleCircleMarker[i])
              }
            }
            // 每个弧形
            for (const i in this.angleSemi) {
              if (i.indexOf(toolId) !== -1) {
                this.groupDeleteLayer(this.angleSemi[i], layers)
                this.$rgMap.removeLayer(this.angleSemi[i])
              }
            }
            // 每个弧形
            for (const i in this.angleTooltip) {
              if (i.indexOf(toolId) !== -1) {
                this.groupDeleteLayer(this.angleTooltip[i], layers)
                this.$rgMap.removeLayer(this.angleTooltip[i])
              }
            }
          })
        this.pointsAngle = []
        this.$rgMap.off('mousemove', this.onMove)
        this.$rgMap.off('dblclick')
        $('#toolBox').removeClass('canotclick')
        // clearTimeout(this.timer) // 先清定时器
      }
      if (this.markerType !== 4) {
        // 不是测距测面测角操作
        this.removeCrosshairClass()
        this.isDrawing = false
        // 不是测角
        if (this.markerType !== 6) {
          this.showPopDiv = true
          this.setPopPosition(e)
          this.toolName = ''
          this.$nextTick(() => {
            this.$refs.toolName.focus()
          })
        }
      }
    },

    onMapClick(e) {
      this.clickType = e.type
      if (!this.isDrawing) return
      if (this.markerType === 1) {
        // 标点
        this.removeCrosshairClass()
        this.isDrawing = false
        this.dotTimeStr = new Date().getTime()
        this.currentToolId = this.dotTimeStr
        this.sendPointInfo = e
        this.dotState = false
        this.global.markerObjDot[this.dotTimeStr] = L.marker(e.latlng, {
          icon: this.dotIcon,
          draggable: false,
          toolId: this.dotTimeStr
        })
          .addTo(this.global.manualLayerGroup)
          .on('dblclick', (e) => {
            this.canDelete = false
            this.clickType = e.type
            this.eventPoint = e
            this.markerType = 1
            this.setPopPosition(e)
            this.showPopDiv = true
            this.popTitle = '标点信息'
            this.setPopPosition(e)
            if (e.target._popup) {
              // 保存到后端了
              this.toolName = e.target._popup._content
              this.dotState = true
            } else {
              // 还未保存到后端
              this.toolName = ''
              this.dotState = false
            }
            this.$nextTick(() => {
              this.$refs.toolName.focus()
            })
          })
          .addTo(this.$rgMap)
          .on('click', (e) => {
            this.currentToolId = e.target.options.toolId
            this.eventPoint = e
            this.markerType = 1
            this.canDelete = true
          })
        this.showPopDiv = true
        this.setPopPosition(e)
        this.toolName = ''
        this.$nextTick(() => {
          this.$refs.toolName.focus()
        })
      }
      if (this.markerType === 2) {
        //标线
        this.sendLineInfo = e
        this.setPopPosition(e)
        this.points.push([e.latlng.lat, e.latlng.lng])
        this.lines.addLatLng(e.latlng)
        this.$rgMap.addLayer(this.lines)
        this.lineTimeStrCircle = new Date().getTime()
        this.tempCircleMarker[this.lineTimeStrCircle] = addCircleMarker(
          e.latlng,
          this.lineTimeStrCircle
        ).addTo(this.$rgMap)
        this.$rgMap.on('mousemove', this.onMove)
      }
      if (this.markerType === 3) {
        //标面
        this.sendAreaInfo = e
        this.setPopPosition(e)
        this.pointsA.push([e.latlng.lat, e.latlng.lng])
        this.linesA.addLatLng(e.latlng)
        this.$rgMap.addLayer(this.tempLinesA)
        this.$rgMap.addLayer(this.linesA)
        this.areaTimeStrCircle = new Date().getTime()
        this.areaTempCircleMarker[this.areaTimeStrCircle] = addCircleMarker(
          e.latlng,
          this.areaTimeStrCircle
        ).addTo(this.$rgMap)
        this.$rgMap.on('mousemove', this.onMove) // 双击地图
      }

      if (this.markerType === 6) {
        // 测角
        console.log('测角地图点击')
        this.sendAngleInfo = e
        this.pointsAngle.push([e.latlng.lat, e.latlng.lng])
        this.angles[this.angleTimeStr]
          .addLatLng(e.latlng)
          .setStyle({
            color: this.measureRed,
            weight: 3
          })
          .addTo(this.global.manualLayerGroup)
        this.$rgMap.addLayer(this.global.manualLayerGroup)
        this.angleTimeStrCircle = new Date().getTime()
        this.angleTempCircleMarker[this.angleTimeStrCircle] = addCircleMarker(
          e.latlng,
          this.angleTimeStrCircle,
          this.measureRed
        ).addTo(this.$rgMap)
        this.$rgMap.on('mousemove', this.onMove)
        this.calculateAngle()
      }
    },
    onMove(e) {
      if (this.markerType === 2) {
        //标线
        if (this.points && this.points.length > 0) {
          let ls = [this.points[this.points.length - 1], [e.latlng.lat, e.latlng.lng]]
          this.tempLines.setLatLngs(ls)
          this.$rgMap.addLayer(this.tempLines)
          // 处理第一个圆圈会被折线盖住的情况
          if (this.tempCircleMarker[this.lineTimeStrCircle]) {
            this.tempCircleMarker[this.lineTimeStrCircle].remove()
          }
          this.tempCircleMarker[this.lineTimeStrCircle] = addCircleMarker(
            this.sendLineInfo.latlng,
            this.lineTimeStrCircle
          ).addTo(this.$rgMap)
        }
      }
      if (this.markerType === 3) {
        //标面
        if (this.pointsA && this.pointsA.length > 0) {
          let lsA = [
            this.pointsA[this.pointsA.length - 1],
            [e.latlng.lat, e.latlng.lng],
            this.pointsA[0]
          ]
          this.tempLinesA.setLatLngs(lsA)
          // 处理第一个圆圈会被折线盖住的情况
          if (this.areaTempCircleMarker[this.areaTimeStrCircle]) {
            this.areaTempCircleMarker[this.areaTimeStrCircle].remove()
          }
          this.areaTempCircleMarker[this.areaTimeStrCircle] = addCircleMarker(
            this.sendAreaInfo.latlng,
            this.areaTimeStrCircle
          ).addTo(this.$rgMap)
        }
      }
      if (this.markerType === 6) {
        // 测角
        if (this.pointsAngle && this.pointsAngle.length > 0) {
          let ls = [this.pointsAngle[this.pointsAngle.length - 1], [e.latlng.lat, e.latlng.lng]]
          this.tempAngles.setLatLngs(ls)
          this.tempAngles.setStyle({
            color: this.measureRed,
            weight: 3
          })
          this.$rgMap.addLayer(this.tempAngles)
          // 处理第一个圆圈会被折线盖住的情况
          if (this.angleTempCircleMarker[this.angleTimeStrCircle]) {
            this.angleTempCircleMarker[this.angleTimeStrCircle].remove()
          }
          this.angleTempCircleMarker[this.angleTimeStrCircle] = addCircleMarker(
            this.sendAngleInfo.latlng,
            this.angleTimeStrCircle,
            this.measureRed
          ).addTo(this.$rgMap)
        }
      }
    },

    drawLineclick(e) {
      this.currentToolId = e.target ? e.target.options.toolId : e.options.toolId
      this.eventLine = e
      this.canDelete = true
      this.markerType = 2
    },
    drawLineDBclick(e, content) {
      this.currentToolId = e.target.options.toolId
      this.lineState = true
      this.eventLine = e
      this.canDelete = false
      this.showPopDiv = true
      this.popTitle = '标线信息'
      this.setPopPosition(e)
      this.toolName = content
      this.markerType = 2
    },
    drawAreaDBclick(e, content) {
      this.currentToolId = e.target.options.toolId
      this.coverState = true
      this.canDelete = false
      this.eventCover = e
      this.popTitle = '标面信息'
      this.showPopDiv = true
      this.setPopPosition(e)
      this.markerType = 3
      this.toolName = content
    },
    setPopPosition(e) {
      const x = e.containerPoint.x
      const y = e.containerPoint.y
      const mapWidth = $('#' + this.global.configObj.mapId).width()
      const mapHeight = $('#' + this.global.configObj.mapId).height()
      this.$nextTick(() => {
        if (this.isFullScreen) {
          this.pcDealPosition(x, y, mapWidth, mapHeight)
        } else {
          this.webDealPosition(x, y, mapWidth, mapHeight)
        }
      })
    },
    // 客户端页面
    pcDealPosition(x, y, mapWidth, mapHeight) {
      if (mapWidth > x && mapWidth - x < 340) {
        // 到右边边缘了
        $('#pointMarkPop').css('left', x - 360 + 'px')
      } else {
        $('#pointMarkPop').css('left', x + 80 + 'px')
      }
      if (mapHeight > y && mapHeight - y < 240) {
        // 到底部边缘了
        $('#pointMarkPop').css('top', y - 200 + 'px')
      } else {
        $('#pointMarkPop').css('top', y - 100 + 'px')
      }
      // 到顶部边缘了
      if (y < 200) {
        $('#pointMarkPop').css('top', y + 'px')
      }
    },
    // 平台页面
    webDealPosition(x, y, mapWidth, mapHeight) {
      if (mapWidth > x && mapWidth - x < 340) {
        // 到右边边缘了
        $('#pointMarkPop').css('left', x - 160 + 'px')
      } else {
        $('#pointMarkPop').css('left', x + 280 + 'px')
      }
      if (mapHeight > y && mapHeight - y < 240) {
        // 到底部边缘了
        $('#pointMarkPop').css('top', y - 150 + 'px')
      } else {
        $('#pointMarkPop').css('top', y - 40 + 'px')
      }
      // 到顶部边缘了
      if (y < 200) {
        $('#pointMarkPop').css('top', y + 'px')
      }
    },
    drawAreaclick(e) {
      this.currentToolId = e.target ? e.target.options.toolId : e.options.toolId
      this.eventCover = e
      this.canDelete = true
      this.markerType = 3
    },
    addCrosshairClass() {
      $('#' + this.global.configObj.mapId).addClass('crosshairCursor')
    },
    removeCrosshairClass() {
      $('#' + this.global.configObj.mapId).removeClass('crosshairCursor')
    },
    // 测角工具计算角度
    calculateAngle() {
      let len = this.pointsAngle.length
      if (len < 3) return
      if (
        this.pointsAngle[len - 1][0] === this.pointsAngle[len - 2][0] &&
        this.pointsAngle[len - 1][1] === this.pointsAngle[len - 2][1]
      ) {
        // 如果是双击的画，要把最后一个重复的去掉
        this.pointsAngle.pop()
      }
      let line1Point = []
      let intersectionPoint = []
      let line2Point = []
      line1Point = [this.pointsAngle[len - 3][0], this.pointsAngle[len - 3][1]]
      intersectionPoint = [this.pointsAngle[len - 2][0], this.pointsAngle[len - 2][1]]
      if (this.pointsAngle[len - 1]) {
        // 最后一个点不计算
        line2Point = [this.pointsAngle[len - 1][0], this.pointsAngle[len - 1][1]]
        const vector1 = this.calculateVector(intersectionPoint, line1Point)
        const vector2 = this.calculateVector(intersectionPoint, line2Point)
        let angle = this.calculateAngleBetweenVectors(vector1, vector2)
        const angleTooltipTimeStrs = this.angleTimeStr + '_tooltip_' + len
        this.angleTooltip[angleTooltipTimeStrs] = L.tooltip({
          className: 'angle-line',
          permanent: true,
          offset: [5, 5]
        })
          .setLatLng(intersectionPoint)
          .setContent(angle.toFixed(2) + '°')
          .openOn(this.global.manualLayerGroup)
        this.drawARC(line1Point, intersectionPoint, line2Point, len)
      }
    },
    // 画角度的小圆弧
    drawARC(line1Point, intersectionPoint, line2Point, len) {
      // 获取两点角度
      let startAngleNum = calcAngleNorth(intersectionPoint, line1Point, this.global)
      let stopAngleNum = calcAngleNorth(intersectionPoint, line2Point, this.global)
      let startAngle = 0
      let stopAngle = 0
      // 注意处理小于180°的角度
      if (Math.abs(startAngleNum - stopAngleNum) > 180) {
        if (stopAngleNum > startAngleNum) {
          startAngle = stopAngleNum - 360
          stopAngle = startAngleNum
        } else {
          startAngle = startAngleNum - 360
          stopAngle = stopAngleNum
        }
      } else {
        if (stopAngleNum > startAngleNum) {
          startAngle = stopAngleNum
          stopAngle = startAngleNum
        } else {
          startAngle = startAngleNum
          stopAngle = stopAngleNum
        }
      }
      const zoom = this.$rgMap.getZoom()
      const radius = this.getRadiusByZoom(zoom)
      const angleSemiTimeStrs = this.angleTimeStr + '_semi_' + len
      this.angleSemi[angleSemiTimeStrs] = L.semiCircle(
        intersectionPoint, // 扇形原点坐标---也就是设备坐标
        {
          radius: radius || 0, // 半径 目前看以米为单位
          startAngle: startAngle || 0, // 起始线与正北的夹角 例如：0度就是以正北0度为起点
          stopAngle: stopAngle || 0, // 也与正北向夹角
          fill: false,
          stroke: true,
          color: this.measureRed,
          weight: 2
        }
      )
        .addTo(this.global.manualLayerGroup)
        .bringToBack()
    },
    // 找的一个比较合理的视觉效果的数值
    getRadiusByZoom(zoom) {
      return 1536000 / Math.pow(2, zoom)
    },
    calculateVector(start, end) {
      const lat = end[0] - start[0]
      const lon = end[1] - start[1]
      return { lat, lon }
    },
    calculateAngleBetweenVectors(vector1, vector2) {
      const dotProduct = vector1.lat * vector2.lat + vector1.lon * vector2.lon
      const magnitudeProduct =
        Math.sqrt(vector1.lat ** 2 + vector1.lon ** 2) *
        Math.sqrt(vector2.lat ** 2 + vector2.lon ** 2)
      const angle = Math.acos(dotProduct / magnitudeProduct)
      return angle * (180 / Math.PI) // Convert to degrees
    },
    // 与正北方向夹角
    bearing(start, end) {
      let rad = Math.PI / 180,
        lat1 = start.latitude * rad,
        lat2 = end.latitude * rad,
        lon1 = start.longitude * rad,
        lon2 = end.longitude * rad
      const a = Math.sin(lon2 - lon1) * Math.cos(lat2)
      const b =
        Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)

      return this.radiansToDegrees(Math.atan2(a, b))
    },
    radiansToDegrees(radians) {
      const degrees = radians % (2 * Math.PI)
      return (degrees * 180) / Math.PI
    },
    // 关闭叉号
    closePopAction() {
      this.cancelClick()
    },
    // 取消
    cancelClick() {
      this.showPopDiv = false
      $('#toolBox').removeClass('canotclick')
      this.markerFlag = false
      const layers = this.global.manualLayerGroup._layers
      if (this.markerType === 1) {
        // 取消标点
        if (!this.dotState) {
          // 未存储的点，点取消需要清除
          if (this.global.markerObjDot[this.currentToolId]) {
            this.groupDeleteLayer(this.global.markerObjDot[this.currentToolId], layers)
            this.$rgMap.removeLayer(this.global.markerObjDot[this.currentToolId])
          }
        }
      }
      if (this.markerType === 2) {
        if (!this.lineState) {
          // 取消时，清空刚刚添加的圆圈
          for (const i in this.circleMarker) {
            if (i.indexOf(this.lineTimeStr) !== -1) {
              this.groupDeleteLayer(this.circleMarker[i], layers)
              this.$rgMap.removeLayer(this.circleMarker[i])
            }
          }
          if (this.global.lineObj[this.currentToolId]) {
            this.groupDeleteLayer(this.global.lineObj[this.currentToolId], layers)
            this.$rgMap.removeLayer(this.global.lineObj[this.currentToolId])
          }
          if (this.lines) {
            this.$rgMap.removeLayer(this.lines)
          }
        }
      }
      if (this.markerType === 3) {
        if (!this.coverState) {
          // // 取消时，清空刚刚添加的圆圈
          for (const i in this.areaCircleMarker) {
            // 刚画的
            if (i.indexOf(this.areaTimeStr) !== -1) {
              this.groupDeleteLayer(this.areaCircleMarker[i], layers)
              this.$rgMap.removeLayer(this.areaCircleMarker[i])
            }
          }
          if (this.global.areaObj[this.currentToolId]) {
            this.groupDeleteLayer(this.global.areaObj[this.currentToolId], layers)
            this.$rgMap.removeLayer(this.global.areaObj[this.currentToolId])
          }
          if (this.linesA) {
            this.$rgMap.removeLayer(this.linesA)
          }
        }
      }
    },
    groupDeleteLayer(data, layers) {
      for (const i in layers) {
        if (data._leaflet_id === Number(i)) {
          this.global.manualLayerGroup.removeLayer(i)
        }
      }
    },
    confirmClick() {
      const name = this.toolName.trim()
      if (name === '') {
        this.$confirm('名称不能为空', '', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
          customClass: 'box-confirm'
        })
          .then(() => {})
          .catch(() => {})
      } else {
        if (this.markerType === 1) {
          // 标点
          if (this.clickType === 'click') {
            // 第一次添加的时候点击确定
            if (judgeName(name)) return
            this.addTool(this.markerType, name, this.sendPointInfo.latlng)
            this.global.markerObjDot[this.timeStr].bindPopup(name)
            this.global.markerObjDot[this.timeStr].on('mouseover', function () {
              this.openPopup()
            })
            this.global.markerObjDot[this.timeStr].on('mouseout', function () {
              this.closePopup()
            })
          } else {
            // 修改后点击确定
            if (judgeName(name)) return
            this.updateTool(this.markerType, this.currentToolId, name)
          }
        }
        if (this.markerType === 2) {
          // 标线
          let sendLineLatLng = []
          this.points.forEach((item) => {
            const isIn = isInArray(sendLineLatLng, item)
            if (!isIn) {
              const obj = {
                lat: item[0],
                lng: item[1]
              }
              sendLineLatLng.push(obj)
            }
          })
          if (this.lineState === false) {
            // 新增时候
            if (judgeName(name)) return
            this.addTool(this.markerType, name, sendLineLatLng)
            this.global.lineObj[this.timeStr].bindPopup(name)
            this.global.lineObj[this.timeStr].on('mouseover', function () {
              this.openPopup()
            })
            this.global.lineObj[this.timeStr].on('mouseout', function () {
              this.closePopup()
            })
            for (let i in this.circleMarker) {
              // 给每一个小圈加上namepopup
              if (i.indexOf(this.timeStr) !== -1) {
                this.circleMarker[i]
                  .bindPopup(name)
                  .on('mouseover', function () {
                    this.openPopup()
                  })
                  .on('mouseout', function () {
                    this.closePopup()
                  })
              }
            }
          } else {
            // 编辑时候
            if (judgeName(name)) return
            this.updateTool(this.markerType, this.currentToolId, name)
          }
        }
        if (this.markerType === 3) {
          // 标面
          let sendAreaLatLng = []
          this.pointsA.forEach((item) => {
            const isIn = isInArray(sendAreaLatLng, item)
            if (!isIn) {
              const obj = {
                lat: item[0],
                lng: item[1]
              }
              sendAreaLatLng.push(obj)
            }
          })
          if (this.coverState === false) {
            // 第一次新增
            if (judgeName(name)) return
            this.addTool(this.markerType, name, sendAreaLatLng)
            this.global.areaObj[this.timeStr].bindPopup(name)
            this.global.areaObj[this.timeStr].on('mouseover', function () {
              this.openPopup()
            })
            this.global.areaObj[this.timeStr].on('mouseout', function () {
              this.closePopup()
            })
            for (let i in this.areaCircleMarker) {
              // 给每一个小圈加上namepopup
              if (i.indexOf(this.timeStr) !== -1) {
                this.areaCircleMarker[i]
                  .bindPopup(name)
                  .on('mouseover', function () {
                    this.openPopup()
                  })
                  .on('mouseout', function () {
                    this.closePopup()
                  })
              }
            }
          } else {
            // 编辑时候
            if (judgeName(name)) return
            this.updateTool(this.markerType, this.currentToolId, name)
          }
        }
      }
    },
    addTool(type, name, latlng) {
      if (this.adding) {
        return
      }
      let latlngArr = []
      if (type === 1) {
        // 点
        const obj = {
          lat: latlng.lat,
          lng: latlng.lng
        }
        latlngArr.push(obj)
        this.timeStr = this.dotTimeStr
      } else if (type === 2) {
        latlngArr = latlng
        this.timeStr = this.lineTimeStr
      } else if (type === 3) {
        latlngArr = latlng
        this.timeStr = this.areaTimeStr
      }
      if (name.trim() === '') {
        return
      }

      const sendData = JSON.stringify({
        toolId: this.timeStr,
        markType: type,
        name: escapeHTMLString(name.trim()),
        lngLat: latlngArr
      })
      this.adding = true
      console.log(sendData)
      httpClient({
        url: this.addRequestUrl,
        method: 'post',
        data: sendData
      }).then((res) => {
        this.markerFlag = false
        if (res.resp_code === 0) {
          this.$message.success('添加成功')
          this.showPopDiv = false
          const obj = {
            lngLat: latlngArr,
            markType: type,
            name: name,
            toolId: this.timeStr
          }
          if (this.markerType === 1) {
            this.dotList.push(obj)
          }
          if (this.markerType === 2) {
            this.lineList.push(obj)
          }
          if (this.markerType === 3) {
            this.areaList.push(obj)
          }
          $('#toolBox').removeClass('canotclick')
          this.adding = false
        } else {
          this.adding = false
        }
      })
      // .catch(() => {
      //   this.adding = false
      //   this.$message.error('网络或服务异常，请检查后重试')
      // })
    },
    updateTool(type, toolId, name) {
      if (this.editing) {
        return
      }
      let data = new FormData()
      data.append('markerType', type)
      data.append('toolId', toolId)
      data.append('name', name)
      this.editing = true
      httpClient({
        url: this.updateRequestUrl,
        method: 'post',
        ContentType: 'application/x-www-form-urlencoded',
        data: data
      }).then((res) => {
        this.editing = false
        this.markerFlag = false
        if (res.resp_code === 0) {
          this.$message.success('更新成功')
          this.showPopDiv = false
          if (this.markerType === 1) {
            this.dotList.forEach((item) => {
              if (item.toolId === this.currentToolId) {
                item.name = name // 更新名称
              }
            })
            if (this.global.markerObjDot[this.currentToolId]) {
              this.global.markerObjDot[this.currentToolId].bindPopup(name) // 更新popup
            }
          }
          if (this.markerType === 2) {
            this.lineList.forEach((item) => {
              if (item.toolId === this.currentToolId) {
                item.name = name // 更新名称
              }
            })
            if (this.global.lineObj[this.currentToolId]) {
              this.global.lineObj[this.currentToolId].bindPopup(name) // 更新popup
              for (let i in this.circleMarker) {
                // 给每一个小圈加上namepopup，直接新建的
                if (i.indexOf(this.currentToolId) !== -1) {
                  this.circleMarker[i].bindPopup(name).on('mouseover', function () {
                    this.openPopup()
                  })
                }
              }
              for (let i in this.circleMarkerSave) {
                // 给每一个小圈加上namepopup，后台存储的
                if (i.indexOf(this.currentToolId) !== -1) {
                  this.circleMarkerSave[i].bindPopup(name).on('mouseover', function () {
                    this.openPopup()
                  })
                }
              }
            }
          }
          if (this.markerType === 3) {
            this.areaList.forEach((item) => {
              if (item.toolId === this.currentToolId) {
                item.name = name // 更新名称
              }
            })
            if (this.global.areaObj[this.currentToolId]) {
              this.global.areaObj[this.currentToolId].bindPopup(name) // 更新popup
              for (let i in this.areaCircleMarker) {
                // 给每一个小圈加上namepopup，直接新建的
                if (i.indexOf(this.currentToolId) !== -1) {
                  this.areaCircleMarker[i].bindPopup(name).on('mouseover', function () {
                    this.openPopup()
                  })
                }
              }
              for (let i in this.areaCircleMarkerSave) {
                // 给每一个小圈加上namepopup，后台存储的
                if (i.indexOf(this.currentToolId) !== -1) {
                  this.areaCircleMarkerSave[i].bindPopup(name).on('mouseover', function () {
                    this.openPopup()
                  })
                }
              }
            }
          }
        }
      })
      // .catch(() => {
      //   this.editing = false
      //   this.$message.error('网络或服务异常，请检查后重试')
      // })
    },
    // 清空
    clearFn() {
      if (!this.isDrawing && !L._startMove) {
        // 其他没有在标线、标面\测距、测面、测角的过程中
        this.$confirm('确定清空所有的地图标注？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'custom-cancel-btn',
          customClass: 'empty-box',
          type: 'warning'
        }).then(() => {
          this.removeAllSure()
        })
        // .catch(() => {
        //   $('#toolBox').removeClass('canotclick')
        // })
      }
    },
    deleteSingle(toolId) {
      if (this.deleting) {
        return
      }
      let data = new FormData()
      data.append('toolId', toolId)
      this.deleting = true
      httpClient({
        url: this.deleteRequestUrl,
        ContentType: 'application/x-www-form-urlencoded',
        method: 'DELETE',
        data: data
      }).then((res) => {
        this.deleting = false
        if (res.resp_code === 0) {
          let layers = this.global.manualLayerGroup._layers
          if (this.markerType === 1) {
            // 删点
            this.groupDeleteLayer(this.global.markerObjDot[toolId], layers)
            this.$rgMap.removeLayer(this.global.markerObjDot[toolId])
            this.dotList.splice(
              this.dotList.findIndex((item) => item.toolId === toolId),
              1
            )
          }
          if (this.markerType === 2) {
            // 删线
            this.groupDeleteLayer(this.global.lineObj[toolId], layers)
            this.$rgMap.removeLayer(this.global.lineObj[toolId])
            this.lineList.splice(
              this.lineList.findIndex((item) => item.toolId === toolId),
              1
            )
            for (const i in this.circleMarkerSave) {
              // 后台存储的圆圈点点
              if (i.indexOf(toolId) !== -1) {
                this.groupDeleteLayer(this.circleMarkerSave[i], layers)
                this.$rgMap.removeLayer(this.circleMarkerSave[i])
              }
            }
            for (const i in this.circleMarker) {
              // 刚画的的圆圈点点
              if (i.indexOf(toolId) !== -1) {
                this.groupDeleteLayer(this.circleMarker[i], layers)
                this.$rgMap.removeLayer(this.circleMarker[i])
              }
            }
            if (this.lines) {
              this.$rgMap.removeLayer(this.lines)
            }
          }
          if (this.markerType === 3) {
            // 删面
            this.groupDeleteLayer(this.global.areaObj[toolId], layers)
            this.$rgMap.removeLayer(this.global.areaObj[toolId])
            this.areaList.splice(
              this.areaList.findIndex((item) => item.toolId === toolId),
              1
            )
            for (const i in this.areaCircleMarkerSave) {
              // 后台存储的
              if (i.indexOf(toolId) !== -1) {
                this.$rgMap.removeLayer(this.areaCircleMarkerSave[i])
              }
            }
            for (const i in this.areaCircleMarker) {
              // 刚画的
              if (i.indexOf(toolId) !== -1) {
                this.groupDeleteLayer(this.areaCircleMarker[i], layers)
                this.$rgMap.removeLayer(this.areaCircleMarker[i])
              }
            }
            if (this.linesA) {
              this.$rgMap.removeLayer(this.linesA)
            }
          }
          this.canDelete = false
        } else if (res.resp_code === 1001) {
          // 此处用于token失效时向外部传参
          // actions.setGlobalState({ tokenMsg: '1001' })
        } else {
          this.canDelete = false
        }
      })
      // .catch(() => {
      //   this.deleting = false
      //   this.$message.error('网络或服务异常，请检查后重试')
      // })
    },
    removeAllSure() {
      if (this.emptying) {
        return
      }
      let layers = this.global.manualLayerGroup._layers
      for (let i in layers) {
        this.$rgMap.removeLayer(layers[i])
      }
      for (let i = 0; i < L.measure_distance.length; i++) {
        this.groupDeleteLayer(L.measure_distance[i], layers)
        this.$rgMap.removeLayer(L.measure_distance[i])
      }
      // 还要清除地图联动的线
      for (let i in this.global.linkGroup) {
        if (this.global.linkGroup[i]) {
          this.$rgMap.removeLayer(this.global.linkGroup[i])
        }
      }
      if (this.dotList.length === 0 && this.lineList.length === 0 && this.areaList.length === 0) {
        $('#toolBox').removeClass('canotclick')
        return
      }
      this.emptying = true
      httpClient({
        url: this.emptyRequestUrl,
        method: 'post'
      }).then((res) => {
        this.emptying = false
        if (res.resp_code === 0) {
          this.$rgMap.removeLayer(this.global.manualLayerGroup)
          this.global.manualLayerGroup = L.layerGroup([])
          this.$rgMap.addLayer(this.global.manualLayerGroup) // 防止清空后，再画的时候不显示，先提前add进map
          this.dotList = []
          this.lineList = []
          this.areaList = []
          L.measure_distance = []
          $('#toolBox').removeClass('canotclick')
          this.$message.success('清除成功')
        }
      })
      // .catch(() => {
      //   this.emptying = false
      //   this.$message.error('网络或服务异常，请检查后重试')
      // })
    },
    // 获取点线面数据并画出来
    getToolDatas() {
      httpClient({
        url: this.getListRequestUrl,
        method: 'get'
      }).then((res) => {
        this.markerFlag = true
        this.$rgMap.addLayer(this.global.manualLayerGroup)
        if (res.resp_code === 0) {
          if (!res.data.list[0]) {
            res.data.list[0] = {
              dotList: []
            }
          }
          if (!res.data.list[1]) {
            res.data.list[1] = {
              lineList: []
            }
          }
          if (!res.data.list[2]) {
            res.data.list[2] = {
              areaList: []
            }
          }
          this.dotList = res.data.list[0].dotList
          this.lineList = res.data.list[1].lineList
          this.areaList = res.data.list[2].areaList
          if (this.dotList.length > 0) {
            this.drawDots()
          }
          if (this.lineList.length > 0) {
            this.drawLines()
          }
          if (this.areaList.length > 0) {
            this.drawAreas()
          }
        }
      })
    },
    // 画存储好的点
    drawDots() {
      this.canDelete = false
      this.dotList.forEach((dot) => {
        const latlng = []
        latlng[0] = dot.lngLat[0].lat || '0'
        latlng[1] = dot.lngLat[0].lng || '0'
        this.global.markerObjDot[dot.toolId] = L.marker(latlng, {
          icon: this.dotIcon,
          draggable: false,
          toolId: dot.toolId
        })
          .addTo(this.global.manualLayerGroup)
          .on('dblclick', (e) => {
            this.clickType = e.type
            this.eventPoint = e
            this.dotState = true
            this.currentToolId = e.target.options.toolId
            this.markerType = 1
            this.canDelete = false
            this.showPopDiv = true
            this.popTitle = '标点信息'
            this.setPopPosition(e)
            this.toolName = dot.name
          })
          .on('click', (e) => {
            this.eventPoint = e
            this.markerType = 1
            this.canDelete = true
          })
        this.global.markerObjDot[dot.toolId].bindPopup(dot.name)
        this.global.markerObjDot[dot.toolId].on('mouseover', function () {
          this.openPopup()
        })
        this.global.markerObjDot[dot.toolId].on('mouseout', function () {
          this.closePopup()
        })
      })
    },
    drawLines() {
      this.lineList.forEach((line) => {
        const latlng = []
        line.lngLat.forEach((meta) => {
          const arr = []
          arr[0] = meta.lat
          arr[1] = meta.lng
          latlng.push(arr)
        })
        this.global.lineObj[line.toolId] = L.polyline(latlng, {
          toolId: line.toolId
        })
          .on('dblclick', (e) => {
            this.drawLineDBclick(e, line.name)
          })
          .addTo(this.global.manualLayerGroup)
          .on('click', (e) => {
            this.drawLineclick(e)
          })
        this.global.lineObj[line.toolId].bindPopup(line.name)
        this.global.lineObj[line.toolId].on('mouseover', function () {
          this.openPopup()
        })
        this.global.lineObj[line.toolId].on('mouseout', function () {
          this.closePopup()
        })
        line.lngLat.forEach((meta, index) => {
          const circleIndex = line.toolId + '_' + index
          this.circleMarkerSave[circleIndex] = addCircleMarker(meta, line.toolId)
            .addTo(this.$rgMap)
            .on('dblclick', (e) => {
              this.drawLineDBclick(e, line.name)
            })
            .addTo(this.global.manualLayerGroup)
            .on('click', (e) => {
              this.drawLineclick(e)
            })
            .bindPopup(line.name)
            .on('mouseover', function () {
              this.openPopup()
            })
        })
      })
    },
    drawAreas() {
      this.areaList.forEach((area) => {
        const latlng = []
        area.lngLat.forEach((meta) => {
          const arr = []
          arr[0] = meta.lat
          arr[1] = meta.lng
          latlng.push(arr)
        })
        this.global.areaObj[area.toolId] = L.polygon(latlng, {
          toolId: area.toolId
        })
          .addTo(this.global.manualLayerGroup)
          .on('dblclick', (e) => {
            this.drawAreaDBclick(e, area.name)
          })
          .on('click', (e) => {
            this.drawAreaclick(e)
          })
        this.global.areaObj[area.toolId].bindPopup(area.name)
        this.global.areaObj[area.toolId].on('mouseover', function () {
          this.openPopup()
        })
        this.global.areaObj[area.toolId].on('mouseout', function () {
          this.closePopup()
        })
        area.lngLat.forEach((meta, index) => {
          const circleIndex = area.toolId + '_' + index
          this.areaCircleMarkerSave[circleIndex] = addCircleMarker(meta, area.toolId)
            .addTo(this.global.manualLayerGroup)
            .on('dblclick', (e) => {
              this.drawAreaDBclick(e, area.name)
            })
            .on('click', (e) => {
              this.drawAreaclick(e)
            })
            .bindPopup(area.name)
            .on('mouseover', function () {
              this.openPopup()
            })
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/js/measure/leaflet.measure.css';
#pointMarkPop {
  position: fixed;
  z-index: 9999;
  background: url('../../assets/image/maptool/tool_bg_point-msg.png') no-repeat;
  background-size: 100% 100%;
  width: 260px;
  height: 196px;
}
.popHead {
  color: #76ffff;
  margin: 5px 0 0 16px;
  height: 30px;
}
.close-btn {
  position: absolute;
  right: 20px;
  top: -2px;
  cursor: pointer;
}
.popDiv {
  display: flex;
  margin: 30px 9px 30px 9px;
  .popLabel {
    margin-right: 12px;
    color: #76ffff;
    line-height: 40px;
    font-size: 14px;
  }
}
.popBtn {
  text-align: center;
}
.canotclick {
  pointer-events: none;
}
::v-deep #nameInput {
  display: inline;
  background-image: url('../../assets/image/maptool/tool_point-msg_input_default.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 186px;
  height: 40px;
  background-color: transparent !important;
  border: 0 none !important;
  color: #fff;
}
</style>
